(function () {
    var supportsScrollFade = [
        'home-template',
        'page-about',
        'page-lab',
        'page-studio',
        'page-people',
    ].some(function (className) {
        return document.body.classList.contains(className);
    });

    if (!supportsScrollFade) return;

    var header = document.getElementById('gh-head');
    if (!header) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        header.style.setProperty('--scroll-progress', '1');
        return;
    }

    var START = 0;
    var END = 160;
    var RANGE = END - START;

    var ticking = false;
    function update() {
        var progress = Math.min(1, Math.max(0, (window.scrollY - START) / RANGE));
        header.style.setProperty('--scroll-progress', progress.toFixed(3));
        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
})();
